import { EventBus, GameEvents } from '../core/EventBus';
import { ManagerNotice } from '../data/types';

/**
 * 业务通知出口（脱粉惩罚 / 咖位晋升 / 带资进组解锁 / 通告超时作废 / 训练升级 / 工作解锁）
 *
 * 第七十四批改判（用户拍板）：**⛔ 再入 `managerNotices` 档**。此前同一句话会两边各留一份——
 * 小助理当面口播一遍、经纪人页（页面 5b）再挂一条气泡，人脉红点也跟着亮；用户裁定
 * 「小助理处的通知经纪人不必再通知」⇒ 即时播报归小助理，本系统只负责把它送出去 + 记进行程日志。
 *
 * 保留不动的两件事：
 *  - `PlayerState.managerNotices` 字段与经纪人页的渲染分支**都不删**：旧档已有的历史仍可回看，
 *    新档该数组恒为空（页面只剩招呼语 + 解约入口），人脉未读胶囊自此只由 NPC 打招呼点亮。
 *  - `kind='deadline'` 由 `ScriptSystem` 直接调 `assistantSystem.push`，桥接侧过滤掉（⛔ 播两遍）。
 *
 * 2026-10-25 直签批补一笔：**本类「⛔ 再入档」约束只管 NoticeSystem.push 通道**——免试镜直签
 * 的经纪人戏约（kind='directSign'）由 DirectSignSystem 直接入 `managerNotices` 档（人脉页聊天
 * 回放是它的呈现本体，茄子改令「聊天页发过来自己点开」），不经本类，⛔ 在这里给它开口子。
 */
export class NoticeSystem {
    private static instance: NoticeSystem;

    private constructor() { }

    static getInstance(): NoticeSystem {
        if (!this.instance) {
            this.instance = new NoticeSystem();
        }
        return this.instance;
    }

    /** 推一条业务通知：小助理口播 + 行程日志，⛔ 入经纪人档（见类头改判） */
    push(kind: ManagerNotice['kind'], text: string): void {
        // 小助理同步播报（全局对话框；见 AssistantSystem.init 的监听）
        document.dispatchEvent(new CustomEvent('assistant-manager-notify', {
            detail: { kind, text },
        }));
    }
}

/** 导出单例 */
export const noticeSystem = NoticeSystem.getInstance();
